export default __webpack_public_path__ + "static/media/morning-star.700828e0.svg";